import { useTranslation } from "react-i18next";

import AnalyticsCard from "@/features/certifications/analytics/components/AnalyticsCard";
import MetricList from "@/features/certifications/analytics/components/MetricList";
import { StatsCardProps } from "@/features/certifications/analytics/types";

import "../styles.css";

const EnrollmentSummaryCard = ({
  data,
  isLoading,
  isError,
}: StatsCardProps) => {
  const { t } = useTranslation();
  const prefix = "certification.admin.analytics.summary";

  return (
    <AnalyticsCard
      title={t(`${prefix}.title`)}
      isLoading={isLoading}
      isError={isError}
    >
      {data && (
        <MetricList
          rows={[
            {
              key: "enrollmentsTotal",
              label: t(`${prefix}.enrollmentsTotal`),
              value: data.enrollments.total,
            },
            {
              key: "enrollmentsActive",
              label: t(`${prefix}.enrollmentsActive`),
              value: data.enrollments.active,
            },
            {
              key: "enrollmentsWithdrawn",
              label: t(`${prefix}.enrollmentsWithdrawn`),
              value: data.enrollments.withdrawn,
            },
            {
              key: "invitesPending",
              label: t(`${prefix}.invitesPending`),
              value: data.invites.pending,
            },
            {
              key: "invitesEnrolled",
              label: t(`${prefix}.invitesEnrolled`),
              value: data.invites.enrolled,
            },
            {
              key: "certificatesIssued",
              label: t(`${prefix}.certificatesIssued`),
              value: data.credentials.issued,
            },
            {
              key: "certificatesCancelled",
              label: t(`${prefix}.certificatesCancelled`),
              value: data.credentials.cancelled,
            },
          ]}
        />
      )}
    </AnalyticsCard>
  );
};

export default EnrollmentSummaryCard;
